module.exports = __webpack_public_path__ + "static/media/marc@3x.f1949974.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/team/marc@3x.png
// module id = 259
// module chunks = 1